var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qcm-answer-item",class:[_vm.computedClassnames, { 'cursor-pointer': !_vm.chooseAllAnswers }],on:{"click":_vm.selectAnswer}},[_vm._v(" "+_vm._s(_vm.answer.answer)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }